export default class Color {
  static black = new Color(0, 0, 0);
  static white = new Color(255, 255, 255);

  static fromHex(hex: string): Color {
    if (!hex.length || hex.length === 0) {
      return Color.black;
    }

    if (hex[0] === '#') {
      hex = hex.slice(1);
    }

    if (hex.length === 6) {
      return new Color(
        //
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16)
      );
    } else if (hex.length === 3) {
      return new Color(
        //
        parseInt(hex[0] + hex[0], 16),
        parseInt(hex[1] + hex[1], 16),
        parseInt(hex[2] + hex[2], 16)
      );
    }

    return Color.black;
  }

  static clamp(value: number, min: number, max: number) {
    return value < min ? min : value > max ? max : value;
  }

  constructor(
    public r: number,
    public g: number,
    public b: number
  ) {
    this.r = Color.clamp(Math.floor(r), 0, 255);
    this.g = Color.clamp(Math.floor(g), 0, 255);
    this.b = Color.clamp(Math.floor(b), 0, 255);
  }

  toRgba(alpha: number) {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${alpha})`;
  }
}
